import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Geyser1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.GEYSER1;
}

export default Geyser1PoiTileEntity;
